import {App, Form, Input, Modal} from "antd";

import * as authApi from "@modules/auth/authApi.js";

export default function ChangePasswordModal({open, onClose})
{
	const {message} = App.useApp();
	const [form] = Form.useForm();

	const submit = async () =>
	{
		let vals;
		try { vals = await form.validateFields(); }
		catch { return; }

		try
		{
			await authApi.changePassword(vals.currentPassword, vals.newPassword);
			message.success("Password aggiornata");
			form.resetFields();
			onClose();
		}
		catch (e)
		{
			const code = e?.response?.data?.error;
			const msg = code === "bad_current_password"
				? "Password attuale errata"
				: (code === "weak_password" ? "Nuova password troppo debole (min 10)" : "Operazione non riuscita");
			message.error(msg);
		}
	};

	return (
		<Modal open={open} title="Cambia password" onOk={submit} onCancel={onClose} okText="Aggiorna" destroyOnHidden>
			<Form form={form} layout="vertical">
				<Form.Item name="currentPassword" label="Password attuale" rules={[{required: true, message: "Obbligatoria"}]}>
					<Input.Password autoComplete="current-password"/>
				</Form.Item>
				<Form.Item name="newPassword" label="Nuova password" rules={[{required: true, min: 10, message: "Minimo 10 caratteri"}]}>
					<Input.Password autoComplete="new-password"/>
				</Form.Item>
			</Form>
		</Modal>
	);
}
